import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Time } from "@vidstack/react";
const TimeGroup = () => {
    return (_jsxs("div", { className: "ml-1.5 flex items-center font-medium text-sm", children: [_jsx(Time, { className: "time", type: "current" }), _jsx("div", { className: "mx-1 text-white/80", children: "/" }), _jsx(Time, { className: "time", type: "duration" })] }));
};
TimeGroup.displayName = "TimeGroup";
export default TimeGroup;
